module.exports = __webpack_public_path__ + "img/wellcome-poll.7f29f4bd.png";